import type { OrganizationUserDto, UserType } from "@superblocksteam/shared";

import { reduxApiSlice, UsersTag } from "./index";

const extendedApi = reduxApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listUsers: builder.query<
      OrganizationUserDto[],
      { organizationId: string; type?: UserType }
    >({
      query: ({ organizationId, type }) =>
        `v1/organizations/${organizationId}/users${
          type ? `?${new URLSearchParams({ type }).toString()}` : ""
        }`,
      transformResponse: (response: { data: OrganizationUserDto[] }) =>
        response.data,
      providesTags: [UsersTag],
    }),
  }),
  overrideExisting: false,
});

export const { useListUsersQuery, useLazyListUsersQuery } = extendedApi;
